import { render, staticRenderFns } from "./KegInfoModal.vue?vue&type=template&id=027327da&scoped=true"
import script from "./KegInfoModal.vue?vue&type=script&lang=js"
export * from "./KegInfoModal.vue?vue&type=script&lang=js"
import style0 from "./KegInfoModal.vue?vue&type=style&index=0&id=027327da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027327da",
  null
  
)

export default component.exports